// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LandPage[data-v-13ad3f5e]{position:fixed;display:flex;left:0;right:0;top:0;bottom:0}.LandPage[data-v-13ad3f5e],.LandPage .card[data-v-13ad3f5e]{justify-content:center;align-items:center}.LandPage .card[data-v-13ad3f5e]{gap:1rem;width:320px;height:240px}.LandPage .card .brand-logo[data-v-13ad3f5e]{margin-top:1rem;width:160px}", ""]);
// Exports
module.exports = exports;
